<template>
  <div class="bg-white p-4 radius">
    <div class="d-flex align-items-center">
      <router-link to="/">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;">
          <path
            d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087"
            stroke="#FF7C48"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span class="title ml-2 mt-2">{{ $t("dashboard.text") }}</span>
      </router-link>
    </div>

    <div>
      <div class="mt-4 ml-4">
        <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
          <div class="d-flex align-items-center" style="gap: 2.34rem;">
            <div>
              <h1 class="title">{{ $t("question-set.text") }}</h1>
            </div>
          </div>
        </div>

        <content-loading v-if="isMyQuestionSetsLoading" />
        <div v-else>
          <div class="qcontainer">
            <div class="qcard" v-for="item in myQuestionSets" :key="item._id">
              <div class="qcard--header">
                <div class="d-flex">
                  <div class="qtitle">{{ item.name | translate }}</div>
                  <!-- <div class="qtitle2">{{ item.products.join(", ") }}</div> -->
                </div>
                <div class="d-flex align-items-center qactions">
                  <i
                    class="iconoir-download"
                    style="font-size: 1.5rem; color: #99A1B7; margin-right: .5rem;"
                    v-b-tooltip.hover.top="{ variant: 'main' }"
                    @click="downloadExcel(item._id)"
                    :title="$t('question-set.download')"
                  ></i>
                  <i class="iconoir-trash" @click="deleteById(item)" style="font-size: 1.5rem; color: #99A1B7;"></i>
                </div>
              </div>
              <div class="qs-title">{{ $t("common.description") }}</div>
              <div class="qs-description">
                {{ item.description | translate }}
              </div>

              <div class="qs-title mt-2">{{ $t("task.assignee") }}</div>
              <div class="assignee-wrapper mt-2">
                <organization-member-select :selected="item.assignee" @onSelect="onAssigneeChanged($event, item)" style="min-width: 250px;" />

                <i class="iconoir-info-circle" v-b-tooltip.hover.top="{ variant: 'main' }" title="Atanan Kişi" style="font-size: 1.125rem; color: #C3CCE7; "></i>
              </div>
              <hr />
              <div class="d-flex align-items-center flex-wrap">
                <div class="d-flex align-items-center">
                  <div class="icon"><i class="iconoir-chat-bubble-question"></i></div>
                  <div class="itext">{{ $t("question-set.answered-question-count") }}:</div>
                  <div class="inumber">{{ item.answeredQuestionCount }}/{{ item.questionCount }}</div>
                </div>

                <div class="d-flex align-items-center">
                  <div class="icon"><i class="iconoir-medal"></i></div>
                  <div class="itext">{{ $t("common.point") }}:</div>
                  <div class="inumber">{{ item.score }}</div>
                  <div>
                    <i class="bx bxs-school align-middle" style="font-size: 1.7875rem;"></i>
                    {{ item.organization.name | summary }}
                  </div>
                </div>

                <button class="button accept ml-auto" @click="answerQuestionSet(item)">{{ $t("question-set.answering") }}</button>
              </div>
            </div>
          </div>

          <empty v-if="!myQuestionSetsPagination || myQuestionSetsPagination.docs.length == 0">
            <h5 class="text-center">
              {{ $t("common.no-data") }}
            </h5>
          </empty>

          <!-- Begin: Pagination -->

          <div v-if="myQuestionSetsPagination" class="row mt-4">
            <div class="col">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="request.options.page"
                  :total-rows="myQuestionSetsPagination.totalDocs"
                  :per-page="myQuestionSetsPagination.limit"
                  limit="10"
                  size="sm"
                ></b-pagination>
              </ul>
            </div>
          </div>
          <!-- End: Pagination -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalSelect from "@c/modal-select";
import OrganizationMemberSelect from "@cc/organization-member-select";
import OrganizationQuestionSetAddLibraryForm from "./component/organization-question-set-add-library-form";

export default {
  props: ["scope"],

  components: { ModalSelect, OrganizationQuestionSetAddLibraryForm, OrganizationMemberSelect },
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { no: "asc" } },
        query: {},
      },
    };
  },

  computed: {
    hasOrganizationQuestionSetViewPermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_ADMIN"])) {
        return true;
      }

      return false;
    },

    myQuestionSets() {
      return this.myQuestionSetsPagination?.docs ?? [];
    },
    myQuestionSetsPagination() {
      return this.$store.getters["organizationQuestionSet/myQuestionSetsPagination"];
    },
    organizationQuestionSets() {
      return this.organizationQuestionSetsPagination?.docs ?? [];
    },
    organizationQuestionSetsPagination() {
      return this.$store.getters["organizationQuestionSet/organizationQuestionSetsPagination"];
    },
    isOrganizationQuestionSetsLoading() {
      return this.$store.getters["organizationQuestionSet/isOrganizationQuestionSetsLoading"];
    },
    isMyQuestionSetsLoading() {
      return this.$store.getters["organizationQuestionSet/isMyQuestionSetsLoading"];
    },
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate(), "my");
      },
    },
  },
  methods: {
    async paginate() {
      await this.$store.dispatch("organizationQuestionSet/fetchCurrentUserAssignedQuestionSet", {
        ...this.request,
      });
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationQuestionSet/delete`, item._id);
        this.rightPanelClosed();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async answerQuestionSet(item) {
      window.location.href = `/question-set/answering/${item._id}`;
    },

    rightPanelClosed() {
      this.paginate();
    },
    //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel(questionSetId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const { data: file } = await this.$store.dispatch(`organizationQuestionSet/download`, questionSetId);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./question-set";
</style>
